import type { BadgeProps } from '@leafwell/components';
import type { StrainExcerptFragment } from 'graphql/wp/types-and-hooks';

import { Badge, Link } from '@leafwell/components';
import { useStrainsArchiveUrl } from 'hooks/useStrainsArchive';

export type StrainTypesProps = Pick<
  StrainExcerptFragment['strainTypes'],
  'nodes'
> &
  Partial<Pick<BadgeProps, 'variant'>> & {
    linkable?: boolean;
  };

const StrainType: React.FC<
  Omit<StrainTypesProps, 'nodes'> &
    StrainExcerptFragment['strainTypes']['nodes'][0]
> = ({ linkable, name, slug, variant = 'white' }) => {
  const href = useStrainsArchiveUrl({ strainTypes: [slug] });

  return (
    <Badge
      {...{
        label: linkable ? (
          <Link {...{ href, variant: 'underlineHover' }}>{name}</Link>
        ) : (
          name
        ),
        size: 'xsmall',
        variant,
      }}
    />
  );
};

const StrainTypes: React.FC<StrainTypesProps> = ({
  linkable = false,
  nodes,
  variant,
}) => {
  return nodes?.length ? (
    <ul {...{ className: 'relative flex flex-wrap gap-2' }}>
      {nodes.map(({ name, slug }) => (
        <li {...{ key: slug }}>
          <StrainType {...{ linkable, name, slug, variant }} />
        </li>
      ))}
    </ul>
  ) : null;
};

export default StrainTypes;
